export const apiConstants = {
    routes: {
        // SERVER: 'http://localhost:8080/api/v1/',
        SERVER: 'https://nl-body-knowledge-server.herokuapp.com/api/v1/',
    },
    methods: {
        GET: 'GET',
        POST: 'POST',
        PUT: 'PUT',
        DELETE: 'DELETE'
    },
    headers: {
        JSON: 'application/json',
        ContentType: 'Content-Type',
        Authorization: 'Authorization',
    },
};

export function processServerResponse(response: Response): Promise<any> {
    return response.json()
        .then(json => {
            if ((response.status >= 400 && response.status <= 600) || json.success === false) {
                return Promise.reject(json.error || json.message || 'server error');
            }
            return json;
        })
        .catch(() => {
            return Promise.reject('invalid response from server');
        });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/apiUtils.ts